import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { IModal, Modals } from '../../types/modal'
import { modalClose } from '../../actions/modal'
import { selectModal } from '../../selectors/modal'
import { AppStateType } from '../../reducers'
import { Modal, P } from '../../components'

interface ISlugValidateModalComponent {
  activeModal: IModal
  dispatch: Dispatch
}

export const SlugValidateModalComponent = ({
  activeModal,
  dispatch,
}: ISlugValidateModalComponent) =>
  activeModal.id ? (
    <Modal
      open={activeModal.id === Modals.slugValidationModal}
      type="activeConfirm"
      action={() => {
        if (activeModal.options) {
          activeModal.options.changeSlugCallback()
        }
        dispatch(modalClose())
      }}
      handleClose={() => {
        dispatch(modalClose())
      }}
      title="Slugline validation"
      actionLabel="Change"
      cancelLabel="Ignore & Continue"
    >
      <P>{activeModal.options && activeModal.options.message}</P>
    </Modal>
  ) : null

const mapStateToProps = (state: AppStateType) => ({
  activeModal: selectModal(state),
})

export const SlugValidateModal = connect(mapStateToProps)(
  SlugValidateModalComponent
)
